export const tr = {
    'audience-and-metrika': 'Yandex.Audience ve Yandex.Metrica',
    copied: 'Kopyalandı',
    'copy-error': 'Kopyalama hatası',
    'copy-link': 'Grup ayarlarını panoya kopyala',
    ots: 'OTS',
    'predictor-settings': 'Reklam grubu ayarları',
    'reach-title': 'Gösterimler',
    'reach-title-ots': 'Hedef kitle kapsamı'
};
